import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e21434f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-container" }
const _hoisted_2 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
  fill: "white"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "text"
}
const _hoisted_6 = {
  class: "invite-body-container",
  ref: "inviteLinkContainer"
}
const _hoisted_7 = { class: "invite-details" }
const _hoisted_8 = { class: "invite-name" }
const _hoisted_9 = { class: "invite-info" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" minutes")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("; Video Call")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("; Phone Call")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("; Details provided")
const _hoisted_15 = { class: "invite-price-container" }
const _hoisted_16 = { class: "payment-icon" }
const _hoisted_17 = { class: "invite-share-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "22",
    cy: "22",
    r: "21",
    stroke: "#DA3A34",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.8531 30.8879C11.8447 30.8879 11.8384 30.8879 11.83 30.8879C11.5395 30.8752 11.3101 30.6353 11.3143 30.3449C11.3164 30.2123 11.6258 17.248 24.2449 16.8903V13.1104C24.2449 12.9021 24.3649 12.7127 24.5522 12.6243C24.7374 12.5338 24.9626 12.5611 25.1225 12.6916L33.7429 19.6957C33.8692 19.7988 33.9428 19.9524 33.9428 20.1145C33.9428 20.2765 33.8692 20.4302 33.745 20.5333L25.1246 27.5374C24.9626 27.6679 24.7395 27.6931 24.5522 27.6047C24.3649 27.5163 24.2449 27.3269 24.2449 27.1186V23.3513C13.0169 23.5555 12.4108 30.105 12.3898 30.387C12.3708 30.6711 12.1351 30.8879 11.8531 30.8879Z",
    fill: "#DA3A34"
  })
], -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.invite)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["invite-link", {inactive: !$setup.linkActive}]),
        onClick: $setup.handleClick
      }, [
        _createElementVNode("div", _hoisted_1, [
          ($setup.linkActive)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "OFF"))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.linkName), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($props.invite.minutes), 1 /* TEXT */),
              _hoisted_11,
              ($props.invite.location.type=='video')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_12
                  ], 64 /* STABLE_FRAGMENT */))
                : ($props.invite.location.type=='phone')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_13
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($props.invite.location.type=='physical')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("; " + _toDisplayString($props.invite.location.fields.city) + ", " + _toDisplayString($props.invite.location.fields.state), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : ($props.invite.location.type=='other')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _hoisted_14
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
            ])
          ])
        ], 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            ($props.invite.collector)
              ? (_openBlock(), _createBlock($setup["VPaidIcon"], {
                  key: 0,
                  type: "YouPayMe"
                }))
              : (_openBlock(), _createBlock($setup["VPaidIcon"], {
                  key: 1,
                  type: "IPayYou"
                }))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["invite-payment", {payout:!$props.invite.collector}])
          }, _toDisplayString($props.invite.price.currency) + _toDisplayString($props.invite.price.amount), 3 /* TEXT, CLASS */)
        ]),
        _createElementVNode("div", _hoisted_17, [
          ($setup.linkActive)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "share-icon-container",
                onClick: _withModifiers($setup.handleShareClick, ["stop"])
              }, _hoisted_20, 8 /* PROPS */, _hoisted_18))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}